import ActivityChart from './ActivityChart'

export default ActivityChart
